const { default: axiosIns } = require('@/libs/axios')

const TargetingService = {
  // GET - TargetingApiController
  async getCustomTargetingProperty(propertyId, targetingPropertyId, accountId) {
    return axiosIns.get(`/properties/${propertyId}/targeting/${targetingPropertyId}?accountId=${accountId}`).then(response => response.data)
  },
  // POST - TargetingApiController
  async createCustomTargetingProperty(propertyId, model, accountId) {
    return axiosIns.post(`/properties/${propertyId}/targeting?accountId=${accountId}`, model).then(response => response.data)
  },
  async createCustomTargetingOption(propertyId, targetingPropertyId, model, accountId) {
    return axiosIns.post(`/properties/${propertyId}/targeting/${targetingPropertyId}/option?accountId=${accountId}`, model).then(response => response.data)
  },
  // DELETE - TargetingApiController
  async deleteCustomTargetingProperty(propertyId, targetingPropertyId, accountId) {
    return axiosIns.delete(`/properties/${propertyId}/targeting/${targetingPropertyId}?accountId=${accountId}`).then(response => response.data)
  },
  async deleteCustomTargetingOption(propertyId, targetingPropertyId, targetingOptionId, accountId) {
    return axiosIns.delete(`/properties/${propertyId}/targeting/${targetingPropertyId}/option/${targetingOptionId}?accountId=${accountId}`).then(response => response.data)
  },
}

export default TargetingService
